import * as React from "react";
import EnrollmentPage from "./pages/EnrollmentPage";
import HomePage from "./pages/HomePage";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import "./App.css";
import "antd/dist/antd.min.css";
import "./theme.less";
import { RealmAppProvider } from "./utils/RealmApp";
import TLReceipt from "./modules/TLReceipt";
import { ConfigProvider } from "antd";
import EntryPage from "./pages/EntryPage";
import FoalNotFoundModal from "./components/FoalNotFoundModal";
import { EntryErrorForm } from "./components/EntryErrorForm";
import OwnerChangePage from "./pages/OwnerChangePage";
import RegLookupPage from "./pages/RegLookupPage";
import ResultsPage from "./pages/ResultsPage";
import EarningPage from "./pages/EarningPage";
import OwnerNominatorInfoUpdatePage from "./pages/OwnerNominatorInfoUpdatePage";
import FoalInfoUpdatePage from "./pages/FoalInfoUpdatePage";
import SireEnrollmentRenewalPage from "./pages/SireEnrollmentRenewalPage";
import SireTLReceipt from "./modules/SireTLReceipt";

export default function AppWithRealm() {
  return (
    <RealmAppProvider>
      <App />
    </RealmAppProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<EnrollmentPage />} />
        <Route path="/foal-enrollment" element={<EnrollmentPage />} />
        <Route path="/sire-enrollment" element={<SireEnrollmentRenewalPage />} />
        <Route path="/enrolled" element={<TLReceipt />} />
        <Route path="/sire-enrolled" element={<SireTLReceipt />} />
        <Route path="/entry" element={<EntryPage />} />
        <Route path="/owner-change" element={<OwnerChangePage />} />
        <Route path="/foal-error" element={<FoalNotFoundModal />} />
        <Route path="/entry-error" element={<EntryErrorForm />} />
        <Route path="/registration-lookup" element={<RegLookupPage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/earning" element={<EarningPage />} />
        <Route path="/info-update/:entity/:id" element={<OwnerNominatorInfoUpdatePage />} />
        <Route path="/foal-update" element={<FoalInfoUpdatePage />} />
      </Routes>
    </BrowserRouter>
  );
}

ConfigProvider.config({
  prefixCls: "custom",
  theme: {
    primaryColor: "#25b864",
  },
});
